import React from 'react';
import Icon from '../../Icon';
import { useNavigate } from 'react-router-dom';
import { remove as removeUser } from '../../../Actions/Person.action';
import { useDispatch } from 'react-redux';

const UserListItemDesktop = ({ person }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <li className="grid grid-cols-5 items-center gap-4 px-2 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-solid [&:not(:last-child)]:border-gray-300 [&:nth-child(even)]:bg-gray-100">
      <p
        className="overflow-hidden text-ellipsis whitespace-nowrap text-sm"
        title={`${person.firstName} ${person.lastName}`}
      >
        {person.firstName} {person.lastName}
      </p>
      <p
        className="overflow-hidden text-ellipsis whitespace-nowrap text-sm"
        title={person.email}
      >
        {person.email}
      </p>
      <p
        className="overflow-hidden text-ellipsis whitespace-nowrap text-sm"
        title={person.phone}
      >
        {person.phone}
      </p>
      <p
        className="overflow-hidden text-ellipsis whitespace-nowrap text-sm"
        title={person.role}
      >
        {person.role}
      </p>
      {person.role !== 'Admin' && (
        <div className="flex justify-end lg:gap-2">
          <button
            className="btn btn--clear btn--small text-primary-500"
            onClick={() => navigate(`edit/${person.systemId}`)}
          >
            <Icon
              name="edit"
              id="edit"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
          </button>
          <button
            className="btn btn--clear btn--small text-error-500"
            onClick={() => {
              dispatch(removeUser(person.systemId));
            }}
          >
            <Icon
              name="delete"
              id="delete"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
          </button>
        </div>
      )}
    </li>
  );
};

export default UserListItemDesktop;
